module.exports = __webpack_public_path__ + "static/media/nasumoshi_logo.44f60b16.png";